<template>
<div>
      <b-modal id="matterStopCustomsFormModal" ref="matterStopCustomsFormModal" centered size="lg" no-close-on-backdrop :title= "$t('matter.matter_stop_customs')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
            <b-card>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterStopCustoms.law_authority_customs_office') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawAuthorityCustomsOfficeSelect" value-field="id" text-field="name" :options="lawAuthorityCustomsOfficeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-decision-no-input">{{ $t('matterStopCustoms.decision_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="matter-stop-customs-decision-no-input" v-model="decisionNo" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-decision-date-input">{{ $t('matterStopCustoms.decision_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="decisionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-opposite-side-input">{{ $t('matterStopCustoms.opposite_side') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-opposite-side-input" size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-sender-input">{{ $t('matterStopCustoms.sender') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-sender-input" size="sm" v-model="lawCounterPartySenderSelect" value-field="id" text-field="name" :options="lawCounterPartySenderOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-bearer-input">{{ $t('matterStopCustoms.bearer') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-bearer-input" size="sm" v-model="lawCounterPartyBearerSelect" value-field="id" text-field="name" :options="lawCounterPartyBearerOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-type-of-shipment-input">{{ $t('matterStopCustoms.type_of_shipment') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-type-of-shipment-input" size="sm" v-model="typeOfShipmentSelect" value-field="id" text-field="name" :options="typeOfShipmentOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-visit-date-input">{{ $t('matterStopCustoms.visit_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="visitDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="matter-stop-customs-goods-quantity-input">{{ $t('matterStopCustoms.goods_quantity') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="matter-stop-customs-goods-quantity-input" v-model="goodsQuantity" type="number" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                     <b-form>
                        <label for="matter-stop-customs-extension-request-date-input">{{ $t('matterStopCustoms.extension_request_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="extensionRequestDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                     <b-form>
                        <label for="matter-stop-customs-extended-deadline-input">{{ $t('matterStopCustoms.extended_deadline') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="extendedDeadline" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                    <label for="matter-stop-customs-extension-request-status-input">{{ $t('matterStopCustoms.extension_request_status') }}</label>
                     <b-form-group>
                            <b-form-select id="matter-stop-customs-extension-request-status-input" size="sm" v-model="lawExtensionRequestStatusSelect" value-field="id" text-field="name" :options="lawExtensionRequestStatusOptions" />
                     </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                     <b-form>
                        <label for="matter-stop-customs-law-product-category-input">{{ $t('matterStopCustoms.law_product_category') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-law-product-category-input" size="sm" v-model="lawProductCategorySelect" value-field="id" text-field="name" :options="lawProductCategoryOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-stop-customs-law-product-type-input">{{ $t('matterStopCustoms.law_product_type') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-law-product-type-input" size="sm" v-model="lawProductTypeSelect" value-field="id" text-field="name" :options="lawProductTypeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-stop-customs-law-storage-input">{{ $t('matterStopCustoms.law_storage') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-stop-customs-law-storage-input" size="sm" v-model="lawStorageSelect" value-field="id" text-field="name" :options="lawStorageOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="matter-stop-customs-goods-input">{{ $t('matterStopCustoms.goods') }}</label>
                        <b-form-group>
                            <b-form-textarea id="matter-stop-customs-goods-input" :placeholder=" $t('matterStopCustoms.goods')" v-model="goods" rows="2" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
              <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="matter-stop-customs-note">{{ $t('matterStopCustoms.note') }}</label>
                        <b-form-group>
                            <b-form-textarea id="matter-stop-customs-note" :placeholder=" $t('matterStopCustoms.note')" v-model="note" rows="2" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
           </b-card>            
      </b-modal>
</div>
</template>

  
<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            office: '',
            decisionNo: '',
            decisionDate: null,
            typeOfShipmentSelect: 0,
            typeOfShipmentOption: [],
            visitDate: null,
            goodsQuantity: '',
            goods: '',
            lawMatterId: 0,
            lawCounterPartyOptions: [],
            lawCounterPartySelect: 0,
            lawCounterPartySenderOptions: [],
            lawCounterPartySenderSelect: 0,
            lawCounterPartyBearerOptions: [],
            lawCounterPartyBearerSelect: 0,
            lawExtensionRequestStatusOptions: [],
            lawExtensionRequestStatusSelect: 0,
            extensionRequestDate: null,
            extendedDeadline :null,
            lawStorageOptions: [],
            lawStorageSelect: 0,
            lawProductCategoryOptions: [],
            lawProductCategorySelect: 0,
            lawProductTypeOptions: [],
            lawProductTypeSelect: 0,
            lawAuthorityCustomsOfficeOptions: [],
            lawAuthorityCustomsOfficeSelect: 0,
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            note: ''
        }
    },
    methods: {
        async showStopCustoms(id, lawMatterId) {
            this.$refs['matterStopCustomsFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = {id: this.id }
            const controller = { name: 'LawMatterStopCustoms' }
            const payload = { data: data,controller: controller }
               
            const response =  await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.office = response.data.lawMatterStopCustoms.office
                    this.decisionNo = response.data.lawMatterStopCustoms.decisionNo
                    this.decisionDate = response.data.lawMatterStopCustoms.decisionDate
                    this.extensionRequestDate = response.data.lawMatterStopCustoms.extensionRequestDate
                    this.extendedDeadline = response.data.lawMatterStopCustoms.extendedDeadline
                    this.visitDate = response.data.lawMatterStopCustoms.visitDate
                    this.goodsQuantity = response.data.lawMatterStopCustoms.goodsQuantity
                    this.goods = response.data.lawMatterStopCustoms.goods,
                    this.note = response.data.lawMatterStopCustoms.note

                    this.typeOfShipmentOption = response.data.lawTypeOfShipmentList
                    this.typeOfShipmentOption.splice(0, 0, this.$nullSelected())
                    this.typeOfShipmentSelect = response.data.lawMatterStopCustoms.typeOfShipmentId
                    
                    this.lawCounterPartyOptions = response.data.lawCounterPartyList
                    this.lawCounterPartyOptions.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartySelect = response.data.lawMatterStopCustoms.lawCounterPartyId

                    this.lawCounterPartySenderOptions = response.data.lawCounterPartySenderList
                    this.lawCounterPartySenderOptions.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartySenderSelect = response.data.lawMatterStopCustoms.lawCounterPartySenderId

                    this.lawCounterPartyBearerOptions = response.data.lawCounterPartyBearerList
                    this.lawCounterPartyBearerOptions.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartyBearerSelect = response.data.lawMatterStopCustoms.lawCounterPartyBearerId

                    this.lawProductCategoryOptions = response.data.lawProductCategoryList
                    this.lawProductCategoryOptions.splice(0, 0, this.$nullSelected())
                    this.lawProductCategorySelect = response.data.lawMatterStopCustoms.lawProductCategoryId

                    this.lawProductTypeOptions = response.data.lawProductTypeList
                    this.lawProductTypeOptions.splice(0, 0, this.$nullSelected())
                    this.lawProductTypeSelect = response.data.lawMatterStopCustoms.lawProductTypeId

                    this.lawAuthorityCustomsOfficeOptions = response.data.lawAuthorityCustomsOfficeList
                    this.lawAuthorityCustomsOfficeOptions.splice(0, 0, this.$nullSelected())
                    this.lawAuthorityCustomsOfficeSelect = response.data.lawMatterStopCustoms.lawAuthorityCustomsOfficeId
                    
                    this.lawExtensionRequestStatusOptions = response.data.lawExtensionRequestStatusList
                    this.lawExtensionRequestStatusOptions.splice(0, 0, this.$nullSelected())
                    this.lawExtensionRequestStatusSelect = response.data.lawMatterStopCustoms.lawExtensionRequestStatusId

                    this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                     this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                     this.lawMatterProcessResultSelect = response.data.lawMatterStopCustoms.lawMatterProcessResultId

                    this.lawStorageOptions.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('matterStopCustomsFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const lawMatterStopCustomsData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            office: this.office,
                            decisionNo: this.decisionNo,
                            decisionDate: this.decisionDate,
                            extensionRequestDate: this.extensionRequestDate,
                            lawExtensionRequestStatusId: this.lawExtensionRequestStatusSelect,
                            extendedDeadline: this.extendedDeadline,
                            lawCounterPartyId :this.lawCounterPartySelect,
                            lawCounterPartySenderId: this.lawCounterPartySenderSelect,
                            lawCounterPartyBearerId: this.lawCounterPartyBearerSelect,
                            lawProductCategoryId :this.lawProductCategorySelect,
                            lawProductTypeId: this.lawProductTypeSelect,
                            lawAuthorityCustomsOfficeId: this.lawAuthorityCustomsOfficeSelect,
                            lawStorageId:this.lawStorageSelect,
                            typeOfShipmentId: this.typeOfShipmentSelect,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect,
                            visitDate: this.visitDate,
                            goodsQuantity: this.goodsQuantity,
                            goods: this.goods,
                            note: this.note
                           
                        }
            const controller = {
                name: 'LawMatterStopCustoms'
            }
            const payload = {
                data: lawMatterStopCustomsData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(4, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterStopCustomsFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
